<template lang="pug">
.select-client-location-tracking-off.mt-5
  .location-setting-options
    i.fa.fa-info-circle.mr-5
    template(v-if="members.length === 1")
      | {{ members[0].name }}'s location setting is turned off.
    template(v-else)
      | Several members location settings are turned off.
    ClientLocationSettingOptions(:members="members")
</template>

<script>
export default {
  name: 'SelectClientLocationTrackingSetting',
  props: {
    members: {
      type: Array,
      required: true,
    },
  },
};
</script>
